import ModalContentWrapper from "root/Modals/ModalContentWrapper";
import { Fragment } from "react";
import React from 'react';
import './ModalGenericMessage.scss';

// width is intentionally left undefined by default so the modal sizes to its
// content (see ModalGenericMessage.scss). Pass width to force a fixed size.
const ModalGenericMessage = ({onSaveComplete, onClose, title, message, messageColour, subtext, width}) =>
{

    const formContent = () =>
    {
        return (
            <div className="generic-message-content">
                <p style={messageColour ? {color: messageColour} : undefined}>{message}</p>
                {subtext && <p style={{color: 'black'}}>{subtext}</p>}
                <div className="generic-message-buttons">
                    <button className="btn btn-primary btn-space-right" onClick={() => onClose()}>Close</button>
                </div>
            </div>
        )
    }

    const headerStyle = {marginBottom: '10px'};

    return (
        <ModalContentWrapper className="modal-generic-message" width={width} columns={1}>
            {
                <Fragment>
                    <h3 style={headerStyle}>{title}</h3>
                    {formContent()}
                </Fragment>
            }
        </ModalContentWrapper>
    )
}

export default ModalGenericMessage;
